import React from "react";
import FieldWrap from "@gqlapp/base/FieldWrap";
import Field from "@gqlapp/forms-client-react/FieldAdapter";
import RenderField from "@xem/look/Renders/Field";

/**
 *
 * @param props
 * @constructor
 */
export const BaseFieldConfig = (props: any) =>{
	let { sx, size, component, ...rest} = props

	return <FieldWrap size={size || 62} sx={{ position: 'relative', zIndex: 1}}>

		<Field
			// shrink
			sx={{
				zIndex: 0,
				'& label':{
					zIndex: 2,
					'& + div':{
						input:{ paddingRight: '15px !important' },
						zIndex: 1,
						'& > div.endAdornment':{
							'&>.remove':{
								marginLeft: '-15px',
								overflow: 'hidden',
								width: '40px'
							}
						}
					}
				},
				'& .endAdornment, & .MuiInputBase-adornedEnd':{  paddingRight: '0px !important' },
				'& .endAdornment':{
					'&>div':{
						'& .btn':{
							paddingRight: '0px !important', width: '35px', marinRight: { marginRight: '0px' }
						}
					}
				},
				...sx
			}}
			{...{ component: component || RenderField }}
			{...rest}
		/>
	</FieldWrap>
}



export function FieldConfig(props:any) {
	return <BaseFieldConfig disabled={false} {...props} />
}


export default BaseFieldConfig;
